<div class="comment-section">
  <!-- Zone d'erreur -->
  <div *ngIf="error" class="alert alert-danger">
    {{ error }}
    <button class="btn-close" (click)="error = null"></button>
  </div>

  <!-- Éditeur de commentaire -->
  <div class="comment-editor card mb-3">
    <div class="card-body">
      <!--
      <div contenteditable="true" #commentTextarea (input)="newComment = commentTextarea.innerHTML"
        class="form-control editable-div mb-3" placeholder="Votre commentaire..."></div>
    -->

      <app-mention-textarea
        #mentionTextarea
        (contentChange)="onContentChange($event)"
        (mentionsChange)="handleMentions($event)"
        placeholder="Votre commentaire..."
      >
      </app-mention-textarea>

      <!-- Fichiers sélectionnés -->
      <div *ngIf="selectedFiles.length" class="mb-2">
        <div
          *ngFor="let file of selectedFiles; let i = index"
          class="d-flex align-items-center mb-1"
        >
          <span class="badge bg-light text-dark me-2">{{ file.name }}</span>
          <button class="btn btn-sm btn-outline-danger" (click)="removeFile(i)">
            &times;
          </button>
        </div>
      </div>

      <!-- Tags avec ng-select -->
      <div class="my-2">
        <ng-select
          [items]="availableTags"
          bindLabel="name"
          [addTag]="true"
          [multiple]="true"
          [loading]="tagsLoading"
          [(ngModel)]="selectedTags"
          (ngModelChange)="onTagsChange()"
          (search)="onTagSearch($event)"
          (add)="onTagAdd($event)"
          placeholder="Ajouter des tags"
        >
          <ng-template ng-option-tmp let-item="item">
            {{ item.name }}
          </ng-template>
          <ng-template ng-tag-tmp let-search="searchTerm">
            Ajouter "{{ search }}"
          </ng-template>
        </ng-select>
      </div>

      <!-- Actions -->
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <input
            type="file"
            #fileInput
            multiple
            (change)="onFileSelected($event)"
            hidden
          />
          <button
            class="btn btn-sm btn-outline-secondary me-2"
            (click)="fileInput.click()"
          >
            <i class="bi bi-paperclip"></i> Joindre un fichier
          </button>
        </div>
        <button
          *ngIf="!draftMode"
          class="btn btn-primary"
          (click)="postComment()"
          [disabled]="!newComment.trim() || isPosting"
        >
          <span
            *ngIf="isPosting"
            class="spinner-border spinner-border-sm me-1"
          ></span>
          {{ isPosting ? "Publication..." : "Publier" }}
        </button>
      </div>
    </div>
  </div>

  <!-- Liste des commentaires -->
  <div class="comments-list" *ngIf="!hideHistory && !draftMode">
    <!-- En-tête avec bouton de pliage/dépliage -->
    <div
      class="d-flex justify-content-between align-items-center mb-2"
      *ngIf="comments.length > 0 || isLoading"
    >
      <h6 class="mb-0">
        <i class="bi bi-chat-dots me-2"></i>
        {{ "companyInfo.toggleComments" | translate }} ({{ comments.length }})
      </h6>
      <button
        class="btn btn-sm btn-outline-secondary"
        (click)="toggleCommentsExpansion()"
        [attr.aria-expanded]="isCommentsExpanded"
        [attr.aria-label]="'informationCompany.toggleComments' | translate"
      >
        <i
          class="bi"
          [class.bi-chevron-up]="isCommentsExpanded"
          [class.bi-chevron-down]="!isCommentsExpanded"
        ></i>
      </button>
    </div>

    <div *ngIf="isCommentsExpanded">
      <div *ngIf="isLoading && !comments.length" class="text-center py-4">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Chargement...</span>
        </div>
      </div>

      <div
        *ngIf="!isLoading && comments.length === 0"
        class="text-muted text-center py-4"
      >
        Aucun commentaire pour le moment.
      </div>

      <div *ngFor="let comment of comments" class="comment card mb-2">
        <div class="card-body">
          <div class="d-flex align-items-center mb-2">
            <div
              class="avatar bg-primary text-white rounded-circle d-flex align-items-center justify-content-center me-3"
              style="width: 40px; height: 40px"
            >
              {{ comment.authorInitial }}
            </div>
            <div>
              <div class="fw-bold">
                {{ comment.author.firstName }} {{ comment.author.lastName }}
              </div>
              <div class="text-muted small">{{ comment.timeAgo }}</div>
            </div>
          </div>

          <div class="d-flex align-items-start justify-content-between mb-2">
            <div
              class="comment-content flex-grow-1"
              [innerHTML]="sanitizeHtml(comment.content)"
            ></div>
            <button
              *ngIf="isCommentAuthor(comment)"
              class="btn btn-sm btn-link text-danger p-0 ms-2"
              (click)="deleteComment(comment)"
              [disabled]="isDeleting[comment.id]"
              [attr.aria-label]="'commentField.delete' | translate"
              type="button"
            >
              <i *ngIf="!isDeleting[comment.id]" class="bi bi-trash"></i>
              <span
                *ngIf="isDeleting[comment.id]"
                class="spinner-border spinner-border-sm"
              ></span>
            </button>
          </div>

          <!-- Documents joints -->
          <div *ngIf="comment.documents?.length" class="mb-2">
            <div *ngFor="let doc of comment.documents" class="mb-1">
              <div class="document-preview">
                <ng-container *ngIf="doc.isImage; else nonImagePreview">
                  <!-- Afficher directement l'image -->
                  <img
                    [src]="getFullUrl(doc.contentUrl)"
                    [alt]="doc.name"
                    class="img-thumbnail preview-image"
                    (click)="previewFile(doc)"
                  />
                </ng-container>
                <ng-template #nonImagePreview>
                  <a
                    href="javascript:void(0)"
                    (click)="previewFile(doc)"
                    class="text-decoration-none"
                  >
                    <i class="bi" [class.bi-file-earmark]="!doc.isImage"></i>
                    {{ doc.name }}
                  </a>
                </ng-template>
              </div>
            </div>
          </div>

          <!-- Tags -->
          <div *ngIf="comment.tags?.length" class="mb-2">
            <span
              *ngFor="let tag of comment.tags"
              class="badge bg-secondary me-1"
            >
              {{ tag.name }}
            </span>
          </div>
        </div>
      </div>

      <div *ngIf="hasMoreComments" class="text-center mt-2">
        <button
          class="btn btn-outline-primary"
          (click)="loadComments(true)"
          [disabled]="isLoading"
        >
          <span
            *ngIf="isLoading"
            class="spinner-border spinner-border-sm me-1"
          ></span>
          Charger plus de commentaires
        </button>
      </div>
    </div>
  </div>
</div>
